import { ArrowUpRight } from 'lucide-react';
import React from 'react';

export interface WikipediaData {
  title: string;
  extract: string;
  images: string[];
  url: string;
}

interface WikipediaCardProps {
  data: WikipediaData;
  isDarkMode?: boolean;
}

export const WikipediaCard: React.FC<WikipediaCardProps> = ({ data, isDarkMode }) => {
  if (!data) return null;

  return (
    <div className="rounded-xl overflow-hidden bg-transparent">
      <div className={`p-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
        <div className="flex items-center gap-3 mb-3">
          <img
            src="https://upload.wikimedia.org/wikipedia/en/8/80/Wikipedia-logo-v2.svg"
            alt="Wikipedia"
            className="w-8 h-8"
          />
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{data.title}</h3>
        </div>

        <p className={`leading-relaxed ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{data.extract}</p>
      </div>

      {data.images && data.images.length > 0 && (
        <div className="p-4 bg-transparent">
          <h4 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-3">
            📷 Related Images ({data.images.length})
          </h4>
          <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
            {data.images.slice(0, 5).map((image: string, idx: number) => (
              <img
                key={idx}
                src={image}
                alt={`Wikipedia image ${idx + 1}`}
                className="flex-shrink-0 w-40 h-30 object-cover rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer transition-transform"
                onClick={() => {
                  const modal = document.createElement('div');
                  modal.className = 'fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4 cursor-pointer';
                  modal.onclick = () => modal.remove();

                  const img = document.createElement('img');
                  img.src = image;
                  img.className = 'max-w-full max-h-[80vh] object-contain rounded-lg';

                  modal.appendChild(img);
                  document.body.appendChild(modal);
                }}
              />
            ))}
          </div>
        </div>
      )}

      <div className="p-4 text-center">
        <a
          href={data.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 dark:text-white light:text-black hover:underline font-medium"
        >
          Read Full Wikipedia Article
          <ArrowUpRight className='h-4 w-4'></ArrowUpRight>
        </a>
      </div>
    </div>
  );
};

export default WikipediaCard;
